import { colors } from 'app-v2/design-systems'

export type Status = $Values<typeof scannerStatuses>
export const scannerStatuses = {
    NORMAL: 'NORMAL',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS'
}

export const statusToColor = (status: Status, idleColor?: string) => {
    switch (status) {
        case scannerStatuses.ERROR:
            return colors.fieryRed
        case scannerStatuses.SUCCESS:
            return colors.crunchyGreen
        case scannerStatuses.NORMAL:
            return idleColor || colors.white
    }
}
